import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const rowId = event.currentTarget.dataset.rowId
    const content = document.getElementById(rowId)
    const chevron = document.getElementById(rowId + "-chevron")

    if (!content) return

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden")
      if (chevron) chevron.classList.add("rotate-180")
    } else {
      content.classList.add("hidden")
      if (chevron) chevron.classList.remove("rotate-180")
    }
  }
}
